import * as React from "react";
import { SVGProps } from "react";
function SvgShowExpandedBigIcon(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.853 16.854a.5.5 0 0 1 0-.708l3.97-3.97a.25.25 0 0 0 0-.353l-3.97-3.97a.5.5 0 0 1 0-.707l.793-.792a.5.5 0 0 1 .707 0l5.293 5.292a.5.5 0 0 1 0 .708l-5.293 5.293a.5.5 0 0 1-.707 0l-.793-.793Z"
        fill="#000"
      />
    </svg>
  );
}
export default SvgShowExpandedBigIcon;
